// extracted by mini-css-extract-plugin
export default {"info":"InputDetail-module__info__Sg88p","count":"InputDetail-module__count__mYZDR","help":"InputDetail-module__help__Ik3ZQ","error":"InputDetail-module__error__Hh1i2"};